const MINOR_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "for",
  "in",
  "nor",
  "of",
  "on",
  "or",
  "so",
  "the",
  "to",
  "up",
  "yet",
]);

const KNOWN_ACRONYMS = new Set(["AAU", "USA", "AND1", "FC"]); // extend as needed

export function toTitleCase(str) {
  if (!str) return str;
  const words = str.trim().replace(/\s+/g, " ").split(" ");

  return words
    .map((word, i) => {
      const upperWord = word.toUpperCase();
      if (KNOWN_ACRONYMS.has(upperWord)) return upperWord;

      return word
        .split("-")
        .map((part) => {
          if (!part) return part;
          const lower = part.toLowerCase();
          const isEdge = i === 0 || i === words.length - 1;
          if (!isEdge && MINOR_WORDS.has(lower)) return lower;
          return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join("-");
    })
    .join(" ");
}
